// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__VFdra","form":"styles_form__1H3eH"};